import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-16 overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
                ZK FACE
              </span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-github-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-discord-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-telegram-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.product')}</h3>
            <ul className="space-y-2">
              <li><a href="#solution" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.product.features')}</a></li>
              <li><a href="#how-it-works" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.product.technology')}</a></li>
              <li><a href="#use-cases" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.product.useCases')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.product.demo')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.resources')}</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.resources.docs')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.resources.api')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.resources.sdk')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.resources.blog')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.company.about')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.company.careers')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.company.press')}</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.company.contact')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {t('footer.copyright')}
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.legal.privacy')}</a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.legal.terms')}</a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.legal.security')}</a>
              <a href="https://readdy.ai/?ref=logo" className="text-gray-400 hover:text-emerald-400 transition-colors">{t('footer.poweredBy')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
